import * as ko from "knockout";
import entityBase from "entityBase";
import labels from "app/labels";
import * as moment from "moment";

export class meterCell<T> {
  value: T;
  source: string;
  error_label: string;
  has_error: boolean;

  constructor(props) {
    this.value = props?.value;
    this.source = props?.source;
    this.has_error = props?.has_error;
    this.error_label = labels.descr(props?.error_label);
  }
}

export class uploadMeterReading extends entityBase {
  sequence: meterCell<number>;
  meter_name: string;
  meter_value: meterCell<number>;
  reading_date: meterCell<Date>;
  serial_number: string;
  last_meter_value: string;
  last_reading_date: string;
  model: string;
  status: string;
  statusErrors: string;

  rowColor: string;

  constructor(props: any) {
    super();
    this.sequence = new meterCell<number>(props?.sequence);
    this.meter_name = props?.meter_name;
    this.meter_value = new meterCell<number>(props?.meter_value);
    this.reading_date = new meterCell<Date>(props?.reading_date);
    this.serial_number = props?.serial_number;
    this.last_meter_value = props?.last_meter_value;
    this.last_reading_date = props?.last_reading_date;
    this.model = props?.model;
    this.status = props?.status;

    this.rowColor = props?.RowHasError ? "#FFDEAD" : "";

    // build list of errors
    const errorList = [];
    if (this.sequence.has_error) {
      errorList.push(this.sequence.error_label);
    }
    if (this.meter_value.has_error) {
      errorList.push(this.meter_value.error_label);
    }
    if (this.reading_date.has_error) {
      errorList.push(this.reading_date.error_label);
    }
    if (props?.external_error) {
      errorList.push(props?.external_error);
    }

    this.statusErrors = errorList.map((err) => labels.descr(err)).join("\n");
  }
}
